<template>
    <o-table
            :data="hourlyRates"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :checkable="isCheckable"
            :loading="isLoading"
            :mobile-cards="hasMobileCards"
            :paginated="isPaginated"
            :per-page="perPage"
            :pagination-simple="isPaginationSimple"
            default-sort="user.first_name"
            :selected.sync="selected"
            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
    >

        <template>

            <o-table-column #default="{ row }" field="from" label="From" sortable>
                {{ $filters.valueOrDefault('-', $filters.date(row.from)) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="to" label="To" sortable>
                {{ $filters.valueOrDefault('Present', $filters.date(row.to)) }}
            </o-table-column>

            <o-table-column #default="{ row }" field="rate" label="Rate" sortable>
                {{ $filters.currency(row.value) }}
            </o-table-column>

        </template>

      <template #empty>
        <div class="has-text-centered">
          This table is empty!
        </div>
      </template>
    </o-table>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Table from './../../../mixins/Table'

    export default {
        mixins: [Table],

        props: ['userId'],

        computed: {
            ...mapGetters(['hourlyRatesByUserId']),

            hourlyRates() {
                return this.hourlyRatesByUserId(this.userId)
            }
        },

        data() {
            return {
                checkedRows: [],
                selected: {},
                isBordered: false,
                isStriped: true,
                isNarrowed: false,
                isCheckable: true,
                isLoading: false,
                hasMobileCards: true,
                isPaginated: true,
                isPaginationSimple: false,
                perPage: 10,
            }
        }
    }
</script>
